import axiosInstance from '../../../../config/axiosInstance';
const AssetCategoryService = {
    async GetAllAssetCategories(redirectCallback, Start, PageSize, searchQuery, sortColumn, sortDirection, SearchColumns) {
        try {
            Start = Start ?? 1;
            PageSize = PageSize ?? 1000;
            searchQuery = searchQuery ?? "";
            sortColumn = sortColumn ?? "ID";
            sortDirection = sortDirection ?? "DESC";
            SearchColumns = SearchColumns ?? "";
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Setup/GetAssetCategory?ClientID=${ClientID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteAssetCaetgory(ID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Setup/DeleteAssetCategory?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default AssetCategoryService;